import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "rc-app/services/UserService";

import FilterSelect from "rc-app/components/Filter Select";
import SearchBar from "rc-app/components/Search Bar";
import PaginationRounded from "rc-app/components/Pagination";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

import { PropertyCard } from "rc-app/components/Card/propertyCard";
import { CircularProgress } from "@mui/material";

// import MiniDrawer from "rc-app/components/MiniDrawer";
// import MiniFooter from "rc-app/components/MiniFooter";

import UserContext from "rc-app/context/UserContext";
import AlertDialog from "rc-app/components/AlertDialog";
// import Breadcrumbs from "rc-app/components/Breadcrumbs";
import Button from "rc-app/components/Button";
import { getAgencyLogo } from "rc-app/api/agencyActionsApi";
import { determineAgencyType, validateAndCleanSearchInput } from "rc-app/utils";
import { getRegionIds } from "rc-app/api/regionActionsApi";
import Icon from "rc-app/components/Icons";

export const AgencyListing = () => {
  const { isUserExist, setIsUserExist } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // HIGHLIGHT: Added to read/write URL params

  // const [allProperties, setAllProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  // HIGHLIGHT: Get page from URL or default to 1
  const pageFromUrl = parseInt(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(pageFromUrl); // HIGHLIGHT: Initialize with URL value
  const [totalPages, setTotalPages] = useState(0);
  const pageLimit = 10;

  const [filterOpen, setFilterOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [searchHint, setSearchHint] = useState("");
  console.log("_kc", UserService.findRole("customer"));

  const [selectedOption, setSelectedOption] = useState({
    agency: "All",
    lifestyle: "All",
    type: "All",
    contract_type: "All",
  });

  const lifestyle: { [key: string]: string } = {
    History: "History",
    Beach: "Beach",
    Waterfront: "Waterfront",
    Lakefront: "Lakefront",
    Metropolitan: "Metropolitan",
    "Country Living": "Country Living",
    "Wine And Vineyards": "Wine And Vineyards",
    "Eco Friendly": "Eco Friendly",
    Mountain: "Mountain",
    Layouts: "Layouts",
    Investments: "Investments",
    Others: "Others",
  };

  const type: { [key: string]: string } = {
    Apartment: "Apartment",
    Castle: "Castle",
    Estate: "Estate",
    "Free Standing House": "Free Standing House",
    Office: "Office",
    Farmhouse: "Farmhouse",
    Palace: "Palace",
    Penthouse: "Penthouse",
    Shop: "Shop",
    Studio: "Studio",
    Villa: "Villa",
    commercial: "Commercial",
    Layout: "Layout",
    Farmland: "Farmland",
    "Farm house": "Farm house",
    Warehouse: "Warehouse",
    "Office space": "Office space",
    "Meta space": "Meta space",
    Others: "Others",
  };

  const contract_type: { [key: string]: string } = {
    Sale: "Sale",
    Rent: "Rent",
    Lease: "Lease",
    Showcase: "Showcase",
    Investment: "Investment",
    Other: "Other",
  };

  const getAgencyDetails = () => {
    try {
      const details = localStorage.getItem("agencyDetails");
      console.log("agencyLogo1-1", details);
      return details ? JSON.parse(details) : null;
    } catch (error) {
      console.error("Error reading agency details from localStorage:", error);
      return null;
    }
  };

  // const applySearchFilter = (propertiesList: any, searchText = "") => {
  //   if (!searchText.trim()) {
  //     return propertiesList;
  //   }

  //   const searchTermLowerCase = searchText.toLowerCase();

  //   return propertiesList.filter((item: any) => {
  //     const fieldsToCheck = [
  //       item.title,
  //       item.matterport_id,
  //       item.num_bathrooms?.toString(),
  //       item.name,
  //       item.address?.city,
  //       item.property_id,
  //       //Add more option to search
  //       // all address , builders, type,
  //     ];

  //     return fieldsToCheck.some((field) =>
  //       field?.toLowerCase().includes(searchTermLowerCase)
  //     );
  //   });
  // };

  // const applyAllFilters = (propertiesList: any[]) => {
  //   if (!propertiesList || propertiesList.length === 0) {
  //     return [];
  //   }

  //   let filtered = [...propertiesList];

  //   if (searchTerm.trim()) {
  //     filtered = applySearchFilter(filtered, searchTerm);
  //   }

  //   if (selectedOption.type !== "All") {
  //     filtered = filtered.filter(
  //       (property) =>
  //         property.characteristics?.type_of_property === selectedOption.type
  //     );
  //   }

  //   if (selectedOption.lifestyle !== "All") {
  //     filtered = filtered.filter(
  //       (property) =>
  //         property.characteristics?.lifestyle === selectedOption.lifestyle
  //     );
  //   }

  //   if (selectedOption.contract_type !== "All") {
  //     filtered = filtered.filter(
  //       (property) =>
  //         property.characteristics?.contract_type ===
  //         selectedOption.contract_type
  //     );
  //   }
  //   return filtered;
  // };

  async function fetchProperties() {
    try {
      setLoading(true);
      setIsSearching(true);
      const responseAgencyLogo = await getAgencyLogo(
        UserService.getUseremail()
      );
      const agencyTypeDetails = determineAgencyType({
        regions: responseAgencyLogo.region,
      });
      if (agencyTypeDetails.regions[0] === "*") {
        localStorage.setItem(
          "agencyDetails",
          JSON.stringify({
            ...agencyTypeDetails,
            regionsId: agencyTypeDetails.regions,
          })
        );
      } else if (agencyTypeDetails.regions[0] !== "*") {
        const regionsId = await getRegionIds(agencyTypeDetails?.regions);
        localStorage.setItem(
          "agencyDetails",
          JSON.stringify({ ...agencyTypeDetails, regionsId: regionsId })
        );
      }
      console.log("agencyLogo1", agencyTypeDetails, responseAgencyLogo);

      const agencyDetails = getAgencyDetails();
      if (!agencyDetails) {
        console.error("No agency details found in localStorage");
        setLoading(false);
        return;
      }

      const { agencyType, regionsId } = agencyDetails;

      const regionsIdParam = new URLSearchParams();
      if (regionsId && Array.isArray(regionsId)) {
        regionsId.forEach((regionId: any) => {
          regionsIdParam.append("region_ids", regionId);
        });
      }
      const regionsIdString = regionsIdParam.toString();

      const API_BASE_URL = process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL;
      if (!API_BASE_URL) {
        console.error("Missing environment variable");
        setLoading(false);
        return;
      }

      let API_URL;
      if (agencyType === "builder") {
        API_URL = `${API_BASE_URL}/api/v1/realestate/views/mp_digital_twin/agent/properties/${UserService.getUseremail()}?sort_by=created_at&sort_order=-1&page=${
          currentPage - 1
        }&limit=${pageLimit}${
          selectedOption.contract_type !== "All"
            ? `&contract_type=${selectedOption.contract_type}`
            : ""
        }${
          selectedOption.lifestyle !== "All"
            ? `&lifestyle=${selectedOption.lifestyle}`
            : ""
        }${
          selectedOption.type !== "All"
            ? `&type_of_property=${selectedOption.type}`
            : ""
        }${searchTerm.trim() !== "" ? `&q=${searchTerm}` : ""}`;
      } else if (agencyType === "marketing") {
        API_URL = `${API_BASE_URL}/api/v1/realestate/views/mp_digital_twin/network_properties?sort_by=created_at&sort_order=-1&page=${
          currentPage - 1
        }&limit=${pageLimit}&${regionsIdString}&property_visibility=network${
          selectedOption.contract_type !== "All"
            ? `&contract_type=${selectedOption.contract_type}`
            : ""
        }${
          selectedOption.lifestyle !== "All"
            ? `&lifestyle=${selectedOption.lifestyle}`
            : ""
        }${
          selectedOption.type !== "All"
            ? `&type_of_property=${selectedOption.type}`
            : ""
        }${
          searchTerm.trim() !== ""
            ? `&q=${searchTerm}&search_fields=address.city,address.province,address.country,name,title,type_of_property,contract_type,property_id`
            : ""
        }
        `;
      } else {
        console.error("Unknown agency type:", agencyType);
        setLoading(false);
        return;
      }

      console.log("Fetching from:", API_URL);

      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.mp_digital_twin_list) {
        const newProperties = response.data.mp_digital_twin_list;
        // setAllProperties(newProperties);

        // const newlyFilteredProperties = applyAllFilters(newProperties);
        setFilteredProperties(newProperties);

        setTotalPages(response.data.total_mp_digital_twin);
        setIsUserExist(true);
        console.log("Loaded properties:", newProperties.length);
        // console.log("Filtered properties:", newlyFilteredProperties.length);
      }

      setLoading(false);
      setIsSearching(false);
    } catch (error: any) {
      console.error("Error fetching properties:", error);

      if (error.name !== "AbortError" && !axios.isCancel(error)) {
        setIsUserExist(false);
      }

      setLoading(false);
    }
  }

  // Clear search and filter when navigating via breadcrumbs (pathname changes)
  useEffect(() => {
    setSearchTerm("");
    setSelectedOption({
      agency: "All",
      lifestyle: "All",
      type: "All",
      contract_type: "All",
    });
  }, [location.pathname]);

  // HIGHLIGHT: Update URL when page changes
  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set("page", currentPage.toString());
    setSearchParams(params);
  }, [currentPage, setSearchParams, searchParams]);

  // Fetch data when page changes
  useEffect(() => {
    const abortController = new AbortController();

    fetchProperties();

    return () => {
      abortController.abort();
    };
  }, [currentPage]);

  const handleClearFilters = () => {
    setSelectedOption({
      agency: "All",
      lifestyle: "All",
      type: "All",
      contract_type: "All",
    });
    setFilterOpen((pre) => !pre);
  };

  const handleFilter = () => {
    setCurrentPage(1);
    fetchProperties();
  };
  const handleFilterByKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleFilter();
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (
      selectedOption.type == "All" &&
      selectedOption.lifestyle == "All" &&
      selectedOption.contract_type == "All"
    ) {
      fetchProperties();
    }

    return () => {
      abortController.abort();
    };
  }, [
    selectedOption.type,
    selectedOption.lifestyle,
    selectedOption.contract_type,
  ]);

  // Trigger search when searchTerm changes (including when cleared)
  useEffect(() => {
    if (searchTerm == "") {
      const abortController = new AbortController();
      const timerId = setTimeout(() => {
        fetchProperties();
      }, 500);
      return () => {
        clearTimeout(timerId);
        abortController.abort();
      };
    }
    return undefined;
  }, [searchTerm]);

  // useEffect(() => {
  //   if (allProperties.length === 0) {
  //     return undefined;
  //   }

  //   setIsSearching(true);

  //   const timer = setTimeout(() => {
  //     try {
  //       const newlyFilteredProperties = applyAllFilters(allProperties);
  //       setFilteredProperties(newlyFilteredProperties);
  //     } catch (error) {
  //       console.error("Error applying filters:", error);
  //       setFilteredProperties(allProperties);
  //     } finally {
  //       setIsSearching(false);
  //     }
  //   }, 100);
  //   return () => clearTimeout(timer);
  // }, [
  //   // searchTerm,
  //   // allProperties,
  // ]);

  const handleSearch = (newSearchTerm: string) => {
    const validation = validateAndCleanSearchInput(newSearchTerm);
    setSearchHint(validation.message);
    setSearchTerm(validation.cleanedValue);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSearchTerm("");
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const selectName = event.target.name;
    setSelectedOption((prevState) => ({
      ...prevState,
      [selectName]: selectedValue,
    }));
  };

  const handleDetailButton = (
    digital_twin_id: string,
    matterport_id: string
  ) => {
    // HIGHLIGHT: Pass current page as URL parameter when navigating to details
    navigate(
      `/property_details?digitalTwinId=${digital_twin_id}&propertyId=${matterport_id}&page=${currentPage}`,
      {
        state: {
          breadcrumbs: [
            { path: "/", label: "Home" },
            { path: "/agency_list", label: "My Projects" },
            {
              path: `/property_details?digitalTwinId=${digital_twin_id}&propertyId=${matterport_id}`,
              label: "Projects Details",
            },
          ],
          referrer: "/agency_list",
        },
      }
    );
  };

  // console.log("filteredProperties", filteredProperties);

  const [filterCount, setFilterCount] = useState(0);
  useEffect(() => {
    const count = Object.values(selectedOption).filter(
      (value) => value !== "All"
    ).length;
    setFilterCount(count);
  }, [selectedOption]);

  return (
    <>
      {/* <div className="flex flex-col w-full h-screen overflow-y-auto pt-[2.5rem] md:pt-[3rem] lg:pt-[3rem]"> */}
      <div className="flex-grow ">
        {/* <Breadcrumbs /> */}
        <div className="flex flex-start gap-2 px-2">
          <div className="flex flex-1 flex-col">
            <SearchBar
              onSearch={handleSearch}
              placeholder="Search..."
              value={searchTerm}
              onClick={handleFilter}
              onKeyDown={handleFilterByKey}
            />
          </div>
          <div
            className="bg-[#2E4051] flex items-center justify-center rounded-md w-32 shadow-md cursor-pointer"
            onClick={() => setFilterOpen((pre) => !pre)}
          >
            <Button
              children="Filter"
              className="bg-[#2E4051]  rounded-md px-2 h-[40px] text-[0.938rem] "
              onClick={() => console.log("click")}
            />
            {filterCount > 0 && (
              <span className="bg-[#008564] text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                {filterCount}
              </span>
            )}
          </div>
        </div>
        {searchHint && (
          <p className="pl-2 mt-2 text-[10px] italic text-red-400">
            {searchHint}
          </p>
        )}

        {filterOpen && (
          <div className="w-full flex px-2 mt-2">
            <div className="w-full flex flex-col flex-start md:items-center gap-1 py-4 shadow-md bg-white dark:bg-[#161F28] rounded-md ">
              <div className="flex relative w-full px-2">
                <span className="flex text-white font-medium text-xl">
                  Filter
                </span>
                <Icon
                  name="ic-close"
                  className="absolute top-1 right-3 w-4 h-4 cursor-pointer"
                  onClick={() => setFilterOpen((pre) => !pre)}
                />
              </div>
              <div className="flex w-full h-[1px] bg-[#2E4051]" />
              <div className="flex flex-col lg:flex-row w-full pt-2 lg:items-center">
                <div className="w-full flex lg:flex-1 flex-wrap flex-col sm:flex-row md:flex-row justify-center">
                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="type"
                      label="Type"
                      options={["All", ...Object.keys(type)]}
                      value={selectedOption.type}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>

                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="lifestyle"
                      label="Lifestyle"
                      options={["All", ...Object.keys(lifestyle)]}
                      value={selectedOption.lifestyle}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>

                  <div className="w-full sm:w-1/2 md:w-1/3 px-2 mb-2 mx-auto">
                    <FilterSelect
                      name="contract_type"
                      label="Contract Type"
                      options={["All", ...Object.keys(contract_type)]}
                      value={selectedOption.contract_type}
                      className="bg-[#2E4051] text-white"
                      handleChange={handleSelectChange}
                    />
                  </div>
                </div>
                <div className="flex flex-row w-full lg:w-52 xl:w-56 gap-4 justify-end px-2 lg:mt-5">
                  <div className="flex  ">
                    <Button
                      children={`Clear All`}
                      className="bg-[#2E4051] rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px]"
                      onClick={handleClearFilters}
                    />
                  </div>
                  <div className="flex ">
                    <Button
                      children={`Apply`}
                      className="bg-[#008564] rounded-md text-[12px] sm:text-[11px] md:text-[15px] lg:text-[17px] xl:text-[18px] px-4 h-[40px]"
                      onClick={() => {
                        handleFilter();
                        setFilterOpen((pre) => !pre);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <div className="flex min-h-screen justify-center items-center h-64">
            <CircularProgress />
          </div>
        ) : filteredProperties.length > 0 ? (
          <div className="grid gap-3 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 mt-3 px-2">
            {filteredProperties.map((property: any) => (
              <div
                key={property._id}
                className="grid grid-cols-1 pt-2 pb-2.5 px-2 gap-4 rounded-md bg-white dark:bg-[#0C1117] border-[#374B5E] cursor-pointer hover:shadow-[0_45px_75px_-18px_rgba(0,0,0,0.5)] hover:-translate-y-1 transition-all duration-400"
                onClick={() =>
                  handleDetailButton(property._id, property.matterport_id)
                }
              >
                <div className=" flex flex-col gap-4 ">
                  <div className="relative aspect-video rounded-md overflow-hidden bg-gray-100">
                    <img
                      src={property.property_thumbnail || ""}
                      alt="Property thumbnail"
                      className="object-cover w-full max-h-full animate-[skeleton-loading_1s_linear_infinite_alternate]"
                      loading="lazy"
                    />
                    <span
                      className={`flex w-20 absolute right-0 top-0 py-1 px-2 justify-center  rounded border-[#008564] text-[11px] max-sm:text-[8px] text-black font-semibold ${
                        property?.property_visibility === "exclusive"
                          ? "border-[#C58300] bg-gradient-to-r from-[#FFC248] via-[#FFE8BB] to-[#FFC248] text-[#664400]"
                          : "border-[linear-gradient(90deg,#209F26,#00D5F6)] bg-[linear-gradient(90deg,#209F26,#00D5F6)] text-[#002904]"
                      } text-shadow-sm `}
                    >
                      {property?.property_visibility === "exclusive"
                        ? "EXCLUSIVE"
                        : "NETWORK"}
                    </span>
                  </div>
                </div>

                <div className=" flex flex-col justify-between gap-2">
                  <PropertyCard
                    digitalTwin={property}
                    isExclusive={false}
                    amount={property?.pricing}
                    contractType={property.characteristics.contract_type}
                    tours={property.characteristics.total_virtual_tours}
                    isCustomerDetails={false}
                    isDetails={false}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : searchTerm ||
          selectedOption.type !== "All" ||
          selectedOption.lifestyle !== "All" ||
          selectedOption.contract_type !== "All" ? (
          <div className="text-center py-10 text-[#F4F5F7] dark:text-white">
            No properties match your current filters
            {(searchTerm ||
              selectedOption.type !== "All" ||
              selectedOption.lifestyle !== "All" ||
              selectedOption.contract_type !== "All") && (
              <div className="mt-2 text-sm opacity-75">
                Try adjusting your search or filters
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-10 text-[#F4F5F7] dark:text-white">
            No properties found
          </div>
        )}
      </div>
      {totalPages > 0 && !isSearching && filteredProperties.length > 0 && (
        <div className="m-5">
          {!loading && (
            <PaginationRounded
              currentPage={currentPage}
              totalPages={Math.ceil(totalPages / pageLimit)}
              limit={pageLimit}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}

      {!isUserExist && <AlertDialog />}
    </>
  );
};
